export default {
  namespaced: true,
  state: {
    answeredQuestionsCount: 0,
    isDataReady: false,
    isDetailViewActive: false,
    hoveredSpecs: [],
    items: [],
    isLightboxOpen: false,
    questions: [],
    scrollBreakpointMax: 950,
    isSingleProductViewActive: false,
    specs: {},
    variantIndex: 1,
    isQuickViewActive: false,
  },

  getters: {
    answeredQuestionsCount: state => state.answeredQuestionsCount,
    isDataReady: state => state.isDataReady,
    isDetailViewActive: state => state.isDetailViewActive,
    items: state => state.items,
    isLightboxOpen: state => state.isLightboxOpen,
    questions: state => state.questions,
    scrollBreakpointMax: state => state.scrollBreakpointMax,
    isSingleProductViewActive: state => state.isSingleProductViewActive,
    specs: state => state.specs,
    variantIndex: state => state.variantIndex,
    hoveredSpecs: state => state.hoveredSpecs,
    isQuickViewActive: state => state.isQuickViewActive,
  },

  mutations: {
    setState(state, payload) {
      for (let key in payload) state[key] = payload[key]
    },

    setSpec(state, { category, value }) {
      state.specs[category] = value
    },

    setVariantIndex(state, payload) {
      state.variantIndex = payload
    },

    setDetailViewActive(state, payload) {
      state.isDetailViewActive = payload
    },

    setSingleProductViewActive(state, payload) {
      state.isSingleProductViewActive = payload
    },

    setAnsweredQuestionsCount(state, payload) {
      state.answeredQuestionsCount = payload
    },

    addHoverSpecs(state, payload) {
      state.hoveredSpecs.push(payload)
    },

    setDataReady(state) {
      state.isDataReady = true
    },

    clearHoverSpecs(state) {
      state.hoveredSpecs = []
    },

    setLightboxState(state, payload) {
      state.isLightboxOpen = payload
    },

    setQuickViewActive(state, payload) {
      state.isQuickViewActive = payload
    },
  },

  actions: {
    sortItems({ state }) {
      state.items.sort((a, b) => b.relevance - a.relevance)
    },

    calculateRelevance({ state }) {
      state.items.forEach(item => {
        item.relevance = 0
        for (let spec in state.specs) {
          if (state.specs.hasOwnProperty(spec)) {
            const specValue = state.specs[spec]
            const relevance = item.specs[spec][specValue]
            if (relevance != undefined) {
              item.relevance += relevance
            }
          }
        }
      })
    },
  },
}
